import { useMemo, type ReactNode } from 'react';
import cx from 'classnames';
import type { RiskScoreLevelEnum, RiskType } from '@/config';
import { RiskIndicatorBar, type RiskIndicatorBarRisk } from '../RiskIndicatorBar/RiskIndicatorBar';
import { getRiskTypeByLevel } from '@/helpers';

import styles from './RiskBadge.module.sass';

interface RiskBadgeProps {
  level: RiskScoreLevelEnum;
  note?: ReactNode;
  className?: string;
}

export const RiskBadge = ({
  level,
  note,
  className,
}: RiskBadgeProps) => {
  const riskType = useMemo(
    () => getRiskTypeByLevel(level),
    [level]
  );

  const barValue: Record<RiskType, Partial<RiskIndicatorBarRisk>> = {
    trusted: 'low',
    suspicious: 'medium',
    danger: 'high',
    unknown: 'unknown',
  };

  const riskTitle = {
    trusted: 'Low',
    suspicious: 'Medium',
    danger: 'High',
    unknown: 'N/D',
  };

  const classes = cx(styles.risk, styles[`risk--${riskType}`], className);

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <RiskIndicatorBar risk={barValue[riskType]} className={styles.bar} />
        <div className={styles.title}>{riskTitle[riskType]}</div>
      </div>
      {note && <div className={styles.note}>{note}</div>}
    </div>
  );
};

